<template>
    <v-card
        class="mx-auto my-5"
        max-width="344"
    >
      <v-card-text>
        <p class="text-h4 text--primary">
          {{this.question}}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-btn
        @click="dialog = true"
          text
          color="primary accent-4"
          rounded
          
class="elevation-1"
style="width:30%"
        >
          Answer
        </v-btn>
      </v-card-actions>
      <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{this.question}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="answer"
                  label="Answer*"
                  type="text"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
            :disabled="loading"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="save_anwer"
            :disabled="!answer"
            :loading="loading"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-card>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["id", "question"],
  data: () => ({
    dialog: false,
    answer: "",
    loading: false,
  }),
    methods: {
    ...mapActions("faq", ["fetchAllQuestions", "fetchAllAnswers", "addAnswer", "deleteQuestion"]),
      async save_anwer() {
        this.loading = true;
        await this.addAnswer({question: this.question, answer: this.answer});
        await this.deleteQuestion(this.id);
        await this.fetchAllAnswers();
        await this.fetchAllQuestions();
        this.loading = false;
        this.dialog = false;
    },
    } 
};
</script>